// 收藏相关接口
const favourite = {
    is_favourite: '/is_favourite',         // 获取是否收藏
    set_favourite: '/set_favourite',           // 创建收藏
    delete_favourite: '/delete_favourite',        // 删除收藏
}
export default favourite; 